<template>
  <b-modal
    centered
    lazy
    v-model="show"
    title="Node Information"
    ok-title="Submit"
    @ok="addNode"
    @shown="focusMyElement"
  >
    <b-alert variant="danger" class="text-center" v-model="createError" dismissible>
      {{ "Couldn't create node" }}
    </b-alert>
    <b-form-group label="Description" :invalid-feedback="descriptionError">
      <b-form-input
        name="description"
        ref="focusThis"
        required
        v-validate="'required'"
        placeholder="my-macbook-air"
        v-on:keyup.enter="addNode"
        :state="hasDescriptionError"
        v-model.trim="form.description"
        type="text"
        @keyup.native.enter="addNode"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
const DEFAULT = {
  description: ''
}
export default {
  name: 'NodeModal',
  props: {
    networkDescription: { type: String, required: true }
  },
  data: () => ({
    show: true,
    form: { ...DEFAULT },
    createError: false
  }),
  watch: {
    show: function(v) {
      if (!v) {
        this.dismiss()
      }
    }
  },
  computed: {
    hasDescriptionError() {
      return this.fieldBag.description && this.fieldBag.description.dirty && !this.fieldBag.description.valid
        ? false
        : null
    },
    descriptionError() {
      return this.errors.has('description') ? this.errors.first('description') : ''
    }
  },
  methods: {
    dismiss() {
      this.$router.push({ name: 'dashboard' })
    },
    focusMyElement(e) {
      // https://bootstrap-vue.js.org/docs/components/modal/#auto-focus-on-open
      this.$refs.focusThis.focus()
    },
    addNode(event) {
      event.preventDefault()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('node-added', this.form)
          this.$store
            .dispatch('addNode', { network_description: this.networkDescription, ...this.form })
            .then(() => {
              this.dismiss()
            })
            .catch(() => {
              this.createError = true
            })
        } else {
          this.$validator.flag('description', { dirty: true })
        }
      })
    }
  }
}
</script>

<style></style>
